import { PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'youtubesafeUrl'
  })
  export class youtubesafeUrl implements PipeTransform {
      constructor(private _sanitizer: DomSanitizer){}
      transform(link: string): SafeResourceUrl {
        let videoId = this.getVideoId(link);
        let url1 = "https://www.youtube.com/embed/" + videoId;
        return this._sanitizer.bypassSecurityTrustResourceUrl(url1);
      }

      getVideoId(link) {
        var videoId = '';
        if (videoId = link.match(/(\?|&)v=([^&#]+)/)) {
          link = videoId
          link = link.pop();
    
        } else if (videoId = link.match(/(\.be\/)+([^\/]+)/)) {
          link = videoId;
          link = link.pop();
    
        } else if (videoId = link.match(/(\embed\/)+([^\/]+)/)) {
    
          link = videoId;
          link = link.pop().replace('?rel=0', '');;
    
        }
        return link;
      }
  }